export default __webpack_public_path__ + "static/media/lib-4.55363243.jpg";